module.exports = __webpack_public_path__ + "static/media/iceCreamCone.6158b951.png";